"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  optValue: 'full_time',
  optLabel: 'employment.full_time'
}, {
  optValue: 'part_time',
  optLabel: 'employment.part_time'
}, {
  optValue: 'seeking_opportunities',
  optLabel: 'employment.seeking_opportunities'
}, {
  optValue: 'not_employed',
  optLabel: 'employment.not_employed'
}, {
  optValue: 'retired',
  optLabel: 'employment.retired'
}, {
  optValue: 'student',
  optLabel: 'employment.student'
}, {
  optValue: 'prefer_not_answer',
  optLabel: 'education.prefer_not_answer'
}];
exports.default = _default;